import React from 'react';
import { motion } from 'framer-motion';
const cards = [{
  emoji: '🍔',
  title: 'COMIDAS QUE YA CONOCEN',
  description: <>
        Milanesas, hamburguesas, pizza, helados... pero{' '}
        <strong data-id="element-68">con verduras escondidas que no van a detectar</strong>
      </>
}, {
  emoji: '🍽️',
  title: 'NUTRICIÓN COMPLETA',
  description: <>
        <strong data-id="element-69">Hierro, vitaminas, minerales</strong>... todo integrado en sus
        comidas favoritas para que <strong data-id="element-70">crezcan sanos y fuertes</strong>
      </>
}, {
  emoji: '😊',
  title: 'SIN PELEAS NI NEGOCIACIONES',
  description: <>
        <strong data-id="element-71">Tu hijo va a PEDIR estas comidas</strong> porque están realmente
        riquísimas
      </>
}, {
  emoji: '🛒',
  title: 'INGREDIENTES DE SUPERMERCADO',
  description: <>
        Nada raro ni caro. Todo con lo que ya tenés en casa o conseguís en
        cualquier súper o <strong data-id="element-72">almacén de barrio</strong>
      </>
}];
export function FeaturesSection() {
  return <section className="py-16 bg-violet-100" data-id="element-73">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74">
        {/* Top bullets */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-10 space-y-3" data-id="element-75">
          <p className="text-2xl md:text-3xl font-extrabold" data-id="element-76">
            <span className="text-yellow-500" data-id="element-77">⭐</span>{' '}
            <span className="text-violet-600" data-id="element-78">
              No son recetas "saludables"...
            </span>{' '}
            <span className="text-gray-800" data-id="element-79">
              Son las comidas que ya aman pero{' '}
            </span>
            <span className="text-orange-500" data-id="element-80">súper nutritivas</span>
            <span className="text-gray-800" data-id="element-81">, aprenderás a </span>
            <span className="bg-gradient-to-r from-orange-500 via-violet-600 to-emerald-500 bg-clip-text text-transparent" data-id="element-82">
              camuflar
            </span>
            <span className="text-gray-800" data-id="element-83">
              {' '}
              todos los nutrientes que ellos necesitan
            </span>
          </p>
          <p className="text-2xl md:text-3xl font-extrabold" data-id="element-84">
            <span className="text-orange-400" data-id="element-85">📋</span>{' '}
            <span className="text-gray-800" data-id="element-86">Más de </span>
            <span className="text-emerald-600" data-id="element-87">200 recetas probadas</span>{' '}
            <span className="text-gray-800" data-id="element-88">
              por miles de familias de todo el país
            </span>
          </p>
        </motion.div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-89">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-md flex flex-col items-center text-center gap-4" data-id="element-90">
              <span className="text-5xl" data-id="element-91">{card.emoji}</span>
              <h3 className="text-violet-600 font-extrabold text-base uppercase leading-tight" data-id="element-92">
                {card.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-93">
                {card.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}